/** How a card reached the collection, as the form stores it and as the page says it. */
export const acquisitionLabels: Record<string, string> = {
  "postcrossing-official": "Postcrossing Official",
  "friend-family": "Friend or Family",
  "postcrossing-forum": "Postcrossing Forum",
  penpal: "Penpal",
  "penpal-me": "Penpal.me",
  other: "Other",
};

export const acquisitionDetailLabels: Record<string, string> = {
  "round-robin": "Round Robin",
  tag: "Tag",
  lottery: "Lottery",
  swap: "Swap",
  other: "Other",
};

/**
 * How a card came, in words: the type, then the forum detail if there is one
 * ("Postcrossing Forum · Round Robin"). A value with no label is shown as stored rather
 * than dropped, so an unexpected one is still visible.
 */
export function acquisitionLabel(card: { acquisitionType: string; acquisitionDetail: string }) {
  const type = acquisitionLabels[card.acquisitionType] || card.acquisitionType;
  const detail = acquisitionDetailLabels[card.acquisitionDetail] || card.acquisitionDetail;
  return [type, detail].filter(Boolean).join(" · ");
}
